import React from "react";
import { Link } from "react-router-dom";
import { Home, Store, Building2, Factory, Landmark, ArrowUpRight } from "lucide-react";
import { SEGMENTS } from "../data/segments";
import { buildWaUrl, WA_MESSAGES } from "../data/site";
import Reveal from "./Reveal";

const ICONS = {
  home: Home,
  store: Store,
  "building-2": Building2,
  factory: Factory,
  landmark: Landmark,
};

export default function Segments() {
  return (
    <Reveal
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4"
      stagger
      data-testid="segments-grid"
    >
      {SEGMENTS.map((s) => {
        const Icon = ICONS[s.icon] || Home;
        return (
          <a
            key={s.slug}
            href={buildWaUrl(WA_MESSAGES.business + ` (segmen: ${s.title})`)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`segment-${s.slug}`}
            className="group relative rounded-3xl bg-white border border-[#E5E7EB] p-6 md:p-7 hover:-translate-y-2 hover:border-[#FF6B00] hover:shadow-[0_20px_40px_-20px_rgba(255,107,0,0.3)] transition-all overflow-hidden flex flex-col"
          >
            <div className="absolute -top-6 -right-6 w-28 h-28 rounded-full bg-gradient-to-br from-[#FF6B00]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            <div className="w-12 h-12 rounded-xl bg-[#F8FAFC] text-[#0F4C75] group-hover:bg-[#FF6B00] group-hover:text-white flex items-center justify-center transition-colors mb-5">
              <Icon className="w-5 h-5" strokeWidth={2} />
            </div>
            <h3 className="font-display font-bold text-lg text-[#0F4C75] leading-tight">
              {s.title}
            </h3>
            <div className="text-[10px] uppercase tracking-[0.22em] font-semibold text-[#FF6B00] mt-1 mb-3">
              {s.tagline}
            </div>
            <p className="text-xs text-[#1B262C]/70 leading-relaxed flex-1">
              {s.description}
            </p>
            <div className="mt-5 inline-flex items-center gap-1.5 text-xs font-bold text-[#0F4C75]">
              Konsultasi
              <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </div>
          </a>
        );
      })}
    </Reveal>
  );
}
